<template>
  <cac-input-wrapper
    :title="options.label"
    :for="id">
    <cac-select
      :id="id"
      :options="formattedSelectOptions"
      :show-placeholder="false"
      v-model="value"
      :name="options.name"
      class="cac-select"
      @blur.native="blurField(options, $event)"
    />
  </cac-input-wrapper>
</template>

<script>
import CacSelect from "CivicActionCenterComponents/utilities/CACSelect.vue";
import CacInputWrapper from "CivicActionCenterComponents/utilities/CACInputWrapper.vue";
import CustomFieldValidationMixin from "JS/mixins/campaign/civicactioncenter/customFieldValidation";

export default {
  name: "CustomSelect",
  components: { CacSelect, CacInputWrapper },
  mixins: [CustomFieldValidationMixin],
  props: {
    options: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      value: ""
    };
  },
  computed: {
    formattedSelectOptions() {
      return this.options.options.map(option => ({
        value: option,
        label: option
      }));
    }
  }
};
</script>
